import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { HomeownerPoolUser } from '@/features/homeowner-users-pool';

function formatDate(value?: number): string {
  if (typeof value !== 'number' || !Number.isSafeInteger(value) || value < 0) return 'Not available';
  const date = new Date(value * 1000);
  return Number.isNaN(date.getTime()) ? 'Not available' : date.toLocaleString();
}

function verificationLabel(value?: boolean): string {
  if (value === true) return 'Verified';
  if (value === false) return 'Not verified';
  return 'Not available';
}

export function HomeownerPoolDetails({ user }: { user: HomeownerPoolUser }) {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <CardTitle>Authentication identity details</CardTitle>
            <CardDescription>Read-only metadata returned from the homeowner authentication pool.</CardDescription>
          </div>
          <div className="flex gap-2">
            <Badge variant={user.enabled === false ? 'destructive' : 'secondary'}>
              {user.enabled === false ? 'Disabled' : user.enabled === true ? 'Enabled' : 'Enabled state unavailable'}
            </Badge>
            {user.userStatus ? <Badge variant="outline">{user.userStatus}</Badge> : null}
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <dl className="grid gap-5 sm:grid-cols-2">
          <div>
            <dt className="text-muted-foreground text-xs font-medium tracking-wide uppercase">Username</dt>
            <dd className="mt-1 font-mono text-sm break-all">{user.username || 'Not available'}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground text-xs font-medium tracking-wide uppercase">Cognito subject</dt>
            <dd className="mt-1 font-mono text-sm break-all">{user.sub || 'Not available'}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground text-xs font-medium tracking-wide uppercase">Phone number</dt>
            <dd className="mt-1 font-mono text-sm break-all">{user.phoneNumber || 'Not available'}</dd>
            <dd className="text-muted-foreground mt-1 text-xs">{verificationLabel(user.phoneNumberVerified)}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground text-xs font-medium tracking-wide uppercase">Email</dt>
            <dd className="mt-1 text-sm break-all">{user.email || 'Not available'}</dd>
            <dd className="text-muted-foreground mt-1 text-xs">{verificationLabel(user.emailVerified)}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground text-xs font-medium tracking-wide uppercase">Created</dt>
            <dd className="mt-1 text-sm">{formatDate(user.createdAt)}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground text-xs font-medium tracking-wide uppercase">Last updated</dt>
            <dd className="mt-1 text-sm">{formatDate(user.updatedAt)}</dd>
          </div>
        </dl>
      </CardContent>
    </Card>
  );
}
